





























import {Component, Prop, Vue} from 'vue-property-decorator'
import {RegistrationRequest} from '../../lib/kepler/RegistrationRequest'
import Flex from '../proxy/Flex.vue'
import TextField from '../proxy/Inputs/TextField.vue'
import CountryList from '../../lib/kepler/countries'
import CountrySelector from '../CountrySelector.vue'
import SectionDivider from '../SectionDivider.vue'
import {State} from 'vuex-class'
import {ClientTypeState} from '../../store/modules/clientTypes'
import SelectTag from '../proxy/Inputs/SelectTag.vue'
import FormTag from '../proxy/Inputs/FormTag.vue'
import DatePicker from '../DatePicker.vue'
import InputDatePicker from '../proxy/Inputs/InputDatePicker.vue'
import Container from '../proxy/Container.vue'

@Component({
  name: 'RegistrationAccountStep',
  components: {
    Container,
    InputDatePicker,
    DatePicker,
    FormTag,
    SelectTag,
    SectionDivider,
    CountrySelector,
    TextField,
    Flex,
  },
})
export default class RegistrationAccountStep extends Vue {

  @Prop() public registrationRequest!: RegistrationRequest
  @State('clientTypes') public types!: ClientTypeState

  public countries = CountryList
  public valid: boolean = true

  public rules: any = {
    required: (value: string) => !!value || this.$t('registration.required'),
    email: (value: string) => {
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return pattern.test(value) || this.$t('registration.invalid-email')
    },
  }

  public checkIsValid() {
    const m = (this.$refs.accountForm as any)
    if (m.validate()) {
      this.$emit('formValid')
    } else {
      this.$emit('formNotValid')
    }
  }

  protected setBirthDate(birthdate: string) {
    this.registrationRequest.birthdate = birthdate
  }

  protected setClientType(obj: any) {
    this.registrationRequest.isOrganization = obj.type === 'BUSINESS' || obj.type === 'MAINTENANCE'
    this.registrationRequest.client_type_id = obj.id
  }
}
